module.exports = __webpack_public_path__ + "static/media/campus3.7e7efe49.jpg";